module.exports = __webpack_public_path__ + "ptsans.ec8f2cdc.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/assets/fonts/ptsans/ptsans.woff
// module id = 2383
// module chunks = 0